import CustomerDetailsService from "services/customer-details-service";
import CustomerLoyaltyService from "services/loyalty-service";
import UserService from "services/user-service";
import AllProducts from "services/poduct-master-service";

const LOAD_CUSTOMER_DETAILS = "LOAD_CUSTOMER_DETAILS";
const LOAD_LOYALTY_POINTS_DETAILS = "LOAD_LOYALTY_POINTS_DETAILS";
const LOAD_LOYALTY_TIER_CONFIG = "LOAD_LOYALTY_TIER_CONFIG";
const USER_OTP = "USER_OTP";
const PRODUCT_DETAILS = "PRODUCT_DETAILS";

export function loadCustomerDetails(filters) {
  return (dispatch, getState) => {
    return (
      filters !== undefined &&
      CustomerDetailsService.getCustomerDetails(filters).then(
        (customerDetails) => {
          dispatch({
            type: LOAD_CUSTOMER_DETAILS,
            customerDetails: customerDetails,
          });
        }
      )
    );
  };
}

export function loadLoyaltyDetails(mobileNumber, brands) {
  return (dispatch, getState) => {
    const data = brands.businessNames.map(async (item, index) => {
      return await CustomerLoyaltyService.getLoyaltyPointsWithExpiryDetails(
        mobileNumber,
        item.id
      )
        .then((res) => {
          const data = { ...res.data, businessUnitName: item.name };
          const result = {
            customerId: index + 1,
            businessUnitName: data.businessUnitName,
            points: Math.floor(+_.get(data, "businessUnitPoints", 0)),
            processingPoints: Math.floor(+_.get(data, 'processingRedeemPoints', 0)),
            level: {
              name: _.get(data, "tier", ""),
              currentLevel: _.get(data, "currentLevel", ""),
              totalLevelsCount: _.get(data, "totalLevelsCount", ""),
            },
            expires: _.map(data.remainingPointsWithExpiry, (v) => {
              return {
                displayText: this.daysRemaining(v.days),
                points: v.points > 0 ? v.points : 0,
              };
            }),
            isShowLoyaltyHistoryLink: false,
            viewDetails: data.viewDetails,
          };
          return result;
        })
        .catch((res) => {
          console.log(res, "res");
        });
    });

    return Promise.all(data).then((res) => {
      const loyaltypoints = res.filter((x) => x !== undefined);
      dispatch({
        type: LOAD_LOYALTY_POINTS_DETAILS,
        loyaltyPointsDetails: loyaltypoints,
      });
    });
  };
}

export function loadLoyaltyTierConfig(businessUnitId) {
  return (dispatch, getState) => {
    return CustomerLoyaltyService.getLoyaltyTierConfig(businessUnitId).then(
      (loyaltyTiers) => {
        dispatch({
          type: LOAD_LOYALTY_TIER_CONFIG,
          loyaltyTiers: loyaltyTiers,
        });
      }
    );
  };
}

export function getUserOtp(mobile) {
  return (dispatch, getState) => {
    return UserService.getLastOpt(mobile)
      .then((userOtp) => {
        dispatch({
          type: USER_OTP,
          userOtp: userOtp,
        });
      })
      .catch((e) => {
        dispatch({
          type: USER_OTP,
          userOtp: nil,
        });
      });
  };
}

export function loadAllProducts(tenent) {
  return (dispatch, getState) => {
    return AllProducts.getAllProducts(tenent)
      .then((products) => {
        dispatch({
          type: PRODUCT_DETAILS,
          allProducts: products.data,
        });
      })
      .catch((e) => {
        dispatch({
          type: PRODUCT_DETAILS,
          allProducts: nil,
        });
      });
  };
}
// Reducer

export function customerDetailsReducer(state = {}, action) {
  switch (action.type) {
    case LOAD_CUSTOMER_DETAILS: {
      return action.customerDetails;
    }
    default:
      return state;
  }
}

export function loyaltyDetailsReducer(state = [], action) {
  switch (action.type) {
    case LOAD_LOYALTY_POINTS_DETAILS: {
      return action.loyaltyPointsDetails;
    }
    default:
      return state;
  }
}

export function loyaltyTierConfigReducer(state = [], action) {
  switch (action.type) {
    case LOAD_LOYALTY_TIER_CONFIG: {
      return action.loyaltyTiers;
    }
    default:
      return state;
  }
}

export function userOtpReducer(state = [], action) {
  switch (action.type) {
    case USER_OTP: {
      return action.userOtp;
    }
    default:
      return state;
  }
}

export function allProductsReducer(state = [], action) {
  switch (action.type) {
    case PRODUCT_DETAILS: {
      return action.allProducts;
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/routes/CustomerDetails/modules/CustomerDetails.js